import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import StudentReport from '../common/studentreport/StudentReport';
import { saveAs } from 'file-saver'

import './report.css';

import {
  studentGetResult,
  studentGetReport,
} from '../../modules/student';

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentId: this.props.match.params.id,
      studentData: null,
    };
  }

  componentDidMount() {
    const { studentId } = this.state;
    this.props.studentGetResult(studentId).then(res => {
      this.setState({studentData: res});
    })
  }

  onDownloadReport = () => {
    const { studentData, studentId } = this.state;
    
    const hide = message.loading('處理中，請稍候..', 0);
    
    this.props.studentGetReport(studentId).then((res) => {
      const blob = new Blob([res], { type: 'application/pdf' })
      saveAs(blob, `report-${studentData.studentCode}.pdf`);
      setTimeout(hide, 100);
    })

    // capture element
    // var doc = new jsPDF("p", "mm", "a4", true);
    // var width = 210 || doc.internal.pageSize.getWidth();
    // var height = 297 || doc.internal.pageSize.getHeight();
    // // console.log(width, height);

    // const input = document.getElementById('report');
    // html2canvas(input)
    //   .then((canvas) => {
    //     const imgData = canvas.toDataURL('image/png');
    //     const pdf = new jsPDF();
    //     pdf.addImage(imgData, 'JPEG', 0, 0, width, height, '', 'FAST');
    //     // pdf.output('dataurlnewwindow');
    //     pdf.save(`report-${studentData.studentCode}.pdf`);
    //   })
    // ;
  }

  render() {
    const { studentData } = this.state;
    const { } = this.props;
    
    if (studentData) {
      const personalityMap = {
        R: {name_tc: '實際型', name_en: 'Realistic', type: 'R'},
        I: {name_tc: '探究型', name_en: 'Investigative', type: 'I'},
        A: {name_tc: '藝術型', name_en: 'Artistic', type: 'A'},
        S: {name_tc: '社交型', name_en: 'Social', type: 'S'},
        E: {name_tc: '企業型', name_en: 'Enterprising', type: 'E'},
        C: {name_tc: '常規型', name_en: 'Conventional', type: 'C'},
      };
      const totalScore = Object.keys(studentData['totalScore']).map((key) => {return { type: personalityMap[key].name_tc, score: studentData['totalScore'][key] }});
      // console.log('totalScore', totalScore);

      return (
        <div className="report-container">
          <Button type="primary" style={{marginBottom: '20px'}} onClick={() => this.onDownloadReport()}>下載報告</Button>
          <StudentReport
            data={studentData}
            style={{
              height: '842px',
              width: '595px'
            }}
            isOverlay={false}
          />
        </div>
      )
    } else {
      return '';
    }
  }

}


const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
  {
    studentGetResult,
    studentGetReport,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Report);
